import { useTranslation } from "react-i18next";

import { useRequiredContext } from "@lib/utils";
import { MeetingRoomAvailabilityInformationContent } from "@organisms";

import { PanelStackContext } from "../../shared/PanelStack/PanelStackContext";
import { HaNDetailsPage } from "../HaNDetailsPage";

// What the map colours and the sensor and calendar statuses mean
export const RoomSensorInfoPage = () => {
  const { t } = useTranslation();
  const { pop } = useRequiredContext(PanelStackContext);

  return (
    <HaNDetailsPage
      title={t("screen:MeetingRoomDetails")}
      onBack={pop}>
      <MeetingRoomAvailabilityInformationContent className="px-5 py-6" />
    </HaNDetailsPage>
  );
};
